<template>
  <v-card width="100%" v-if="isQueryParamsShowing" flat outlined>
    <v-card-title class="mb-3"> QueryParams </v-card-title>
    <v-card flat outlined class="ma-1">
      <v-card-title class="mb-3"> Report: </v-card-title>
      <v-row v-for="(queryParam, i) in reportQueryParams" :key="i">
        <v-row v-if="queryParam.get()" class="ml-3 mr-3 mt-1">
          <v-col cols="3">
            <p>{{ queryParam.key }}</p>
          </v-col>
          <v-col cols="9">
            <p>{{ queryParam.get() }}</p>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
    <v-card flat outlined class="ma-1">
      <v-card-title class="mb-3"> THG: </v-card-title>
      <v-row v-for="(queryParam, i) in thgQueryParams" :key="i">
        <v-row v-if="queryParam.get()" class="ml-3 mr-3 mt-1">
          <v-col cols="3">
            <p>{{ queryParam.key }}</p>
          </v-col>
          <v-col cols="9">
            <p>{{ queryParam.get() }}</p>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
    <v-card flat outlined class="ma-1">
      <v-card-title class="mb-3"> Attachment Request Token: </v-card-title>
      <v-row class="ml-3 mr-3 mt-1 mb-3">
        <v-col cols="12">
          <p>attachmentRequestToken: {{ attachmentRequestToken }}</p>
          <p>attachmentRequestId: {{ attachmentRequestId }}</p>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script lang="ts">
import { reportHomeQueryParams } from "@/lib/queryParams/reportHomeQueryParams";
import { thgQueryParams } from "@/lib/queryParams/thgQueryParams";
import { AttachmentResponseModule } from "@/store/modules/attachment-response.store";
import { ConfigModule } from "@/store/modules/config";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class QueryParamsList extends Vue {
  get reportQueryParams() {
    return reportHomeQueryParams;
  }

  get thgQueryParams() {
    return thgQueryParams;
  }

  get isQueryParamsShowing() {
    return ConfigModule.debug;
  }

  get attachmentRequestToken() {
    return AttachmentResponseModule.attachmentRequestToken;
  }

  get attachmentRequestId() {
    return AttachmentResponseModule.attachmentRequestId;
  }
}
</script>
